import React from 'react';
import {Button} from 'antd-mobile';
import SportSwiperCard, {SportsItem} from './swiper-card';
import Card, {lightLinear} from '@basicComponents/card';

interface SportFloorProps {
  title: string;
  hasLink?: boolean;
  hasLiveIcon?: boolean;
  sportsList: SportsItem[];
  isSport?: boolean;
  defaultSportIcon?: string;
  onLinkClick?: () => void;
}

const PreIcon = () => {
  return (
    <Button className="bg-[var(--live-bg)] text-white rounded-[0.325rem] text-xs w-[2.5rem] h-[1.2rem] font-size-10 flex items-center justify-center ml-2">
      Live
    </Button>
  );
};

const SportFloor = ({
  title,
  hasLink,
  hasLiveIcon,
  isSport,
  sportsList,
  defaultSportIcon,
  onLinkClick,
}: SportFloorProps) => {
  return (
    <Card>
      <Card.Title
        icon={{
          url: require('@assets/icons/home/little.webp'),
          width: 8,
          height: 8,
        }}
        style={{height: 32}}
        linear={lightLinear}
        title={title}>
        {hasLiveIcon ? <PreIcon /> : null}
        <div className="flex-1 flex flex-row items-center justify-end">
          {hasLink ? (
            <div onClick={onLinkClick} className="text-c1 text-xs font-bold">
              All
            </div>
          ) : undefined}
        </div>
      </Card.Title>
      <div className="w-full pb-3">
        <div className="flex flex-row gap-2 items-center overflow-x-auto hide-scrollbar pl-2 pr-2">
          {sportsList?.map((item, index) => (
            <SportSwiperCard
              key={index}
              item={item}
              isLive={item.isLive}
              isSport={isSport}
              isMix={true}
              icon={defaultSportIcon}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};

export default SportFloor;
